import * as _ from 'lodash';
import * as hash from 'object-hash';
import { Component } from 'react';
import { Dispatch, connect } from "react-redux";
import { AppActionCreators, IAppState } from '@nkr/store/application';
import { IDonorProfilePreSelectLogData, IDonorProfileDeclinesData, IDonorProfileHeaderInfo } from '@nkr/models/index';
import { IBaseDispatchProps, ToggleType } from '../models';
import { DonorActionCreators, IApplicationState, IDonorProfileAcceptsResponse, IDonorProfileDeclinesResponse } from '@nkr/store/index';
import { Panel } from 'react-bootstrap';
import AcceptsView from './accepts-view'
import DeclinesView from './declines-view'

interface IOwnProps {
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    donorId: number
    headerInfo: IDonorProfileHeaderInfo,
    hasDataChanged: boolean,
    saveRequested: boolean,
    refreshRequested: boolean,
    onDataChanged: (hasDataChanged: boolean) => void,
    onRefreshFinished: () => void,
    onResetDataChangedWarning: () => void,
    onTabClick: (href: string) => void,
    onUpdateForErrors: (toggleType: ToggleType, messages: string[]) => void
}

interface IStateProps {
    app: IAppState,
    groupIsSuper: boolean
}

interface IDispatchProps extends IBaseDispatchProps {
    getDeclinesData: (id: number, centerId: number) => Promise<IDonorProfileDeclinesResponse>,
    getAcceptsData: (id: number, centerId: number) => Promise<IDonorProfileAcceptsResponse>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    acceptsData: IDonorProfilePreSelectLogData,
    acceptsDataHash: string,
    declinesData: IDonorProfileDeclinesData,
    declinesDataHash: string,
}

const initialState: IState = {
    acceptsData: null,
    acceptsDataHash: '',
    declinesData: null,
    declinesDataHash: '',
}

class Activity extends Component<TProps, IState> {
    readonly state: IState = initialState;

    componentDidMount = () => {
        this.getData();
    }

    componentWillReceiveProps = (nextProps: Readonly<TProps>, nextContext: any) => {
        if (this.props.saveRequested == false && nextProps.saveRequested == true) {
            // this.confirmFileUploads();
        }

        if (this.props.refreshRequested == false && nextProps.refreshRequested == true) {
            this.getData();
        }
    }

    getData = () => {
        this.props.showLoading('Getting declines, one moment please...').then(() => {
            Promise.all([
                this.props.getAcceptsData(this.props.donorId, this.props.centerId),
                this.props.getDeclinesData(this.props.donorId, this.props.centerId)
            ])
                .then(([acceptsResponse, declineResponse]) => {
                    if (declineResponse.data.success && acceptsResponse.data.success) {
                        let newAcceptData = _.cloneDeep(declineResponse.data.results);
                        let newAcceptHash = hash(newAcceptData);

                        let newDeclineData = _.cloneDeep(declineResponse.data.results);
                        let newDeclineHash = hash(newDeclineData);

                        this.setState({
                            acceptsDataHash: newAcceptHash,
                            acceptsData: acceptsResponse.data.results,
                            declinesDataHash: newDeclineHash,
                            declinesData: declineResponse.data.results
                        }, () => {
                            if (this.props.refreshRequested) {
                                this.props.onRefreshFinished();
                            }
                        });
                    }
                })
                .catch(error => {

                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleAcceptDataChange = (data: IDonorProfilePreSelectLogData) => {
        let newData = _.cloneDeep(data);
        let newHash = hash(newData);

        let hasDataChanged = newHash != this.state.acceptsDataHash;

        this.setState({
            acceptsData: newData,
        });

        this.props.onDataChanged(hasDataChanged);
    }

    handleDeclineDataChange = (data: IDonorProfileDeclinesData) => {
        let newData = _.cloneDeep(data);
        let newHash = hash(newData);

        let hasDataChanged = newHash != this.state.declinesData;

        this.setState({
            declinesData: newData,
        });

        this.props.onDataChanged(hasDataChanged);
    }

    render = () => {
        if (this.props.headerInfo == null)
            return null;

        let { declinesData, acceptsData } = this.state;

        return (
            <div className='container-fluid donor-profile-section donor-records'>
                <Panel>
                    <Panel.Heading>Accepts</Panel.Heading>
                    <Panel.Body>
                        {acceptsData?.preselectLogs ? (
                            <AcceptsView
                                data={acceptsData.preselectLogs}
                                isAdmin={this.props.isAdmin}
                                isCenterView={true}
                            />
                        ) : null}
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>Declines</Panel.Heading>
                    <Panel.Body>
                        <DeclinesView
                            data={declinesData}
                        />
                    </Panel.Body>
                </Panel>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
        groupIsSuper: appState.app.user.group.isSuper,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDeclinesData: (id, centerId) => {
            return dispatch(DonorActionCreators.getProfileDeclinesData(id, centerId));
        },
        getAcceptsData: (id, centerId) => {
            return dispatch(DonorActionCreators.getProfileAcceptsData(id, centerId, false));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Activity);